import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//service
import { setAdminPlusRankingPoints } from "../../../../utils/service/ranking";

function DigitalTechnology(props) {
  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  useEffect(() => {
    document.getElementById("title-digital").focus();
  }, []);
  return (
    <section className="section-digital">
      <a id="title-digital" className="title-home" tabIndex={12}>
        Página Expo Área - Digital Technology Innovation
      </a>
      <div className="div-cards-technology">
        {/* <div className="card-technology">
          <a className="title-card-technology" tabIndex={15}>
            Digital Technology Innovation
          </a>
          <button
            style={{ border: "none", backgroundColor: "white" }}
            title="Clique para abrir a imagem"
            tabIndex={16}
            onClick={() => {
              window.open(
                "https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/EXPO/STAND%20-%20DIGITAL%20TECHNOLOGY%20INNOVATION/Foto%20equipe%20com%20mirai.png",
                "_blank"
              );
              pointAction("DIGITALTECHNOLOGYFOTOEQUIPECOMMIRAI");
            }}
          >
            <i
              className="bx bx-link-external"
              style={{ fontSize: 40, cursor: "pointer" }}
            />
          </button>
        </div> */}

        <div className="card-technology">
          <a
            className="title-card-technology"
            id="title-card-technology"
            tabIndex={17}
          >
            Vídeo Roberto
          </a>
          <video
            width={250}
            controls
            tabIndex={19}
            onPlay={() => pointAction("DIGITALTECHNOLOGYVIDEOROBERTO")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/stand_digtal/Expo%20-%20Digital%20Technology%20Innovation%20%28Roberto%29%20%281%29.mp4" />
          </video>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(DigitalTechnology);
